import { phoneCalls } from '@markku/db'
import { createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export const selectPhoneCallSchema = createSelectSchema(phoneCalls)

// What an officer is allowed to write via `phoneCall.update`. The call itself
// is owned by the webhook / WebRTC flow — officers only relink a call to a
// user/opportunity/customer (e.g. "Luo liidi tästä puhelusta"), mark the call
// as followed-up via `handledAt`, or edit their own summary / notes via
// `operatorNotes`. All other fields (recording/transcript/ai summary/routing
// stage/telnyx ids) are derived state and must not be writable from the
// client.
const nullableFk = z.number().nullable().optional()
export const upsertPhoneCallSchema = z
  .object({
    userId: nullableFk,
    opportunityId: nullableFk,
    customerId: nullableFk,
    handledAt: z.string().datetime().nullable().optional(),
    operatorNotes: z.string().nullable().optional(),
  })
  .strict()

export const selectPhoneCallWithRelationsSchema = selectPhoneCallSchema.extend({
  user: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      phoneNumber: z.string().nullable(),
    })
    .nullable(),
  answerer: z
    .object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
    })
    .nullable(),
  opportunity: z
    .object({
      id: z.number(),
      stage: z.string(),
    })
    .nullable(),
  customer: z
    .object({
      id: z.number(),
      name: z.string(),
    })
    .nullable(),
})

export type PhoneCall = z.infer<typeof selectPhoneCallSchema>
export type PhoneCallWithRelations = z.infer<
  typeof selectPhoneCallWithRelationsSchema
>
export type UpsertPhoneCall = z.infer<typeof upsertPhoneCallSchema>

export type { PhoneCallActionItem, PhoneCallLeg } from '@markku/db'
